import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  media: {
    height: 0,
    paddingTop: '56.25%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    // backgroundBlendMode: 'darken',
  },
  content:{
    margin: '0 28px',
  },
  title: {
    position: 'relative',
    top: '-.5em',
    background: 'linear-gradient(to top, rgba(243, 146, 61, 0.7) 35%, transparent 35%)',
    lineHeight: 1.4,
    fontFamily: 'Noto Sans JP, sans-serif',
    fontStyle: 'normal',
    fontSize: 'calc(2rem + ((1vw - 4.14px) * 1.0929))',
  },
  subtitle:{
    fontSize:"calc(1.5625rem + ((1vw - 4.14px) * 0.4554))", /* 24 - 30*/
    marginTop: "3rem",
    display:'block',
    position: 'relative',

  },
  subtitleShadow:{
    fontSize:"calc(1.625rem + ((1vw - 4.14px) * 2.1858))", /* 26 - 50*/
    color: '#f3923d33',
    fontWeight: 800,
    position: 'absolute',
    bottom: 'calc(0.9375rem + ((1vw - 4.14px) * -1.275))',
    left: '15px',
    margin: '0',

  },
  lightGreen:{
    color: '#75E78733',
  },
  body:{
    fontSize:"17px",
    marginTop: "1rem",
    display:'block',
    fontWeight: 300,
  },
  card: {
    width: '900px',
    maxWidth: '90vw',
    margin: 'auto',
    textAlign: 'left',
    borderRadius: 7,
    padding: '0 0 50px',
    background: '#ffffff30',
    border: '1px solid #D9DCDF',
    backdropFilter: 'blur(50px)',
    boxShadow: 'none',
  },
  section: {
    borderRadius: '20px',
    margin: '10px',
    flex: 1,
  },
  buttonRequest:{
    padding: '10px 50px',
    margin: '50px auto 20px',
    textAlign: 'center',
    background: '#F3923D',
    color: 'white',
    boxShadow: 'none',
    '&:hover':{
      boxShadow: 'none',
      opacity: 0.7,
      background: '#F3923D',
    }
  },
  imageSection: {
    marginLeft: '20px',
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
    },
  },
  recommendedProjects: {
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  loadingPaper: {
    display: 'flex', 
    justifyContent: 'center', alignItems: 'center', padding: '20px', borderRadius: '15px', height: '39vh',
  },
  chip:{
    margin: "5px 4px",
    background: 'rgba(255, 255, 255, 0.4)',
    border: "1px solid #ADADAD",
    borderRadius: "25px",
    padding: '10px 12px',
    color: '#ADADAD',
  },
  projectNameDiv:{
    position: 'absolute',
    top: 0,
    right: 0,
    textAlign: 'right',
    padding: '10px 20px',
    background: 'white',
    width: '170px',
    color: '#333',
    borderBottom: '1.5px solid #D9DCDF',
    borderLeft: '1.5px solid #D9DCDF',
    borderRadius: '0 0 0 7px',
  },
}));